/* **************************************************** Finishing Shedule Type */
export interface FSType {
    id: number;
    category: string;
    type_name: string;
    created_by: number | null;
}

export const mapFSType = (data: any): FSType => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSType = {
        id: data.id,
        category: data.category,
        type_name: data.type_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSTypes = (data: any[]): FSType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSType);
};
